import { render } from "./GestionHuellas.vue?vue&type=template&id=9481569e&scoped=true"
import script from "./GestionHuellas.vue?vue&type=script&lang=js"
export * from "./GestionHuellas.vue?vue&type=script&lang=js"

import "./GestionHuellas.vue?vue&type=style&index=0&id=9481569e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9481569e"]])

export default __exports__